<div class="grid">
  <div class="col-12">
    <div class="card">
      <p-table #dt
               [value]="ouvrages"
               [lazy]="true"
               (onLazyLoad)="loadDatas($event)"
               dataKey="id"
               [rows]="10"
               [loading]="loading"
               [rowHover]="true"
               styleClass="p-datatable-gridlines"
               [paginator]="true"
               [totalRecords]="totalRecords"
               [globalFilterFields]="['CodeProjet']"
               responsiveLayout="scroll">
        <ng-template pTemplate="caption">
          <div class="flex justify-content-between flex-column sm:flex-row">
            <button pButton
                    label="Clear"
                    class="p-button-outlined mb-2"
                    icon="pi pi-filter-slash"
                    (click)="clear(dt)"></button>
          </div>
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>
              <div class="flex justify-content-between align-items-center">
              </div>
            </th>
            <th>
                Code projet
            </th>
            <th>
                Titre
            </th>
            <th>
                Code article
            </th>
            <th>
                EAN
            </th>
            <th>
                Complétion
            </th>
            <th>
                Complétion médias
            </th>
            <th>
                Code œuvre
            </th>
            <th>
                Statut
            </th>
            <th>
                Support
            </th>
            <th>
                Collection
            </th>
            <th>
                Date de mise en vente
            </th>
            <th>
                Matière(s)
            </th>
            <th>
                Classe
            </th>
            <th>
                Assistant d'édition
            </th>
            <th>
                Éditeur interne
            </th>
          </tr>
          <tr>
            <th>
              <div class="flex justify-content-between align-items-center">
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="CodeProjet"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.TitreWEB"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.CodeArticle"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.EAN"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
            </th>
            <th>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.CodeOeuvre"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter field="BaseArticle.StatutArticle"
                                matchMode="equals"
                                [showMenu]="false">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-dropdown [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                [options]="this.getOptions('StatutArticle')"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span [class]="'customer-badge status-' + option.value">{{option.key}}</span>
                      </ng-template>
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.Support"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.CollectionEdito_search"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.DateParution"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.Matieres"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <!--								<p-columnFilter type="text" field="BaseArticle.Classe" display="menu" placeholder="Search by Classe"></p-columnFilter>-->
                <p-columnFilter field="BaseArticle.Classe"
                                matchMode="in"
                                [showMenu]="false"
                                [maxConstraints]=10
                                [showMatchModes]="true"
                                [showOperator]="true"
                                [showAddButton]="true">
                  <ng-template pTemplate="header">
                    <div class="px-3 pt-3 pb-0">
                      <span class="font-bold">Agent Picker</span>
                    </div>
                  </ng-template>
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-multiSelect [ngModel]="value"
                                   [options]="this.getOptions('Classe')"
                                   (onChange)="filter($event.value)"
                                   optionLabel="key"
                                   optionValue="value">
                      <ng-template let-option
                                   pTemplate="item">
                        <div class="p-multiselect-representative-option">
                          <span class="ml-2">{{option.key}}</span>
                        </div>
                      </ng-template>
                    </p-multiSelect>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center" *ngIf="classDef">
                <p-columnFilter field="ouvrage.BaseArticle.AssistantEdito"
                                matchMode="contains"
                                [showMenu]="true">
                  <ng-template pTemplate="filter"
                               let-value
                               let-filter="filterCallback">
                    <p-dropdown [ngModel]="value"
                                optionLabel="key"
                                optionValue="value"
                                placeholder="(Vide)"
                                [editable]="true"
                                [options]="classDef.fdef['AssistantEdito'].options"
                                (onChange)="filter($event.value)"
                                [style]="{'min-width': '12rem'}">
                      <ng-template let-option
                                   pTemplate="item">
                        <span>{{option.key}}</span>
                      </ng-template>
                    </p-dropdown>
                  </ng-template>
                </p-columnFilter>
              </div>
            </th>
            <th>
              <div class="flex justify-content-between align-items-center">
                <p-columnFilter type="text"
                                field="BaseArticle.Editeur"
                                matchMode="contains"
                                [showMenu]="false"></p-columnFilter>
              </div>
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body"
                     let-ouvrage>
          <tr>
            <td style="min-width: 12rem;" class="text-center">
              <a pButton
                      pRipple

                      [routerLink]="['/ressources_numeriques', ouvrage.id]"
                      label="Éditer"
                      class="mr-2 mb-2"></a>
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.CodeProjet}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.TitreWEB}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.CodeArticle}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.EAN}}
            </td>
            <td style="min-width: 12rem;">
              <div role="progressbar"
                   aria-valuemin="0"
                   aria-valuemax="100"
                   class="p-progressbar p-component p-progressbar-determinate">
                <div
                  class="p-progressbar-value p-progressbar-value-animate ng-star-inserted"
                  style="display: flex; width: {{ouvrage.taux_remplissage_rn}}%;">
                  <div
                    class="p-progressbar-label ng-star-inserted"
                    style="display:flex;">{{ouvrage.taux_remplissage_rn}}%
                  </div>
                </div>
              </div>
            </td>
            <td style="min-width: 12rem;">
              <div role="progressbar"
                   aria-valuemin="0"
                   aria-valuemax="100"
                   class="p-progressbar p-component p-progressbar-determinate">
                <div
                  class="p-progressbar-value p-progressbar-value-animate ng-star-inserted"
                  style="display: flex; width: {{ouvrage.taux_remplissage_media}}%;">
                  <div
                    class="p-progressbar-label ng-star-inserted"
                    style="display:flex;">{{ouvrage.taux_remplissage_media}}%
                  </div>
                </div>
              </div>
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.CodeOeuvre}}
            </td>
            <td style="min-width: 12rem;">
              {{this.getOptionsLabel('StatutArticle', ouvrage.BaseArticle.StatutArticle)}}
            </td>
            <td style="min-width: 12rem;">
              {{this.getOptionsLabel('Support', ouvrage.BaseArticle.Support)}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.CollectionEdito_search}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.DateParution | date: 'dd/MM/yyyy'}}
            </td>
            <td style="min-width: 12rem;">
              {{this.getLabelValues(ouvrage.BaseArticle.Matieres, 'Matieres')}}
            </td>
            <td style="min-width: 12rem;">
              {{this.getLabelValues(ouvrage.BaseArticle.Classe, 'Classe')}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.AssistantEdito}}
            </td>
            <td style="min-width: 12rem;">
              {{ouvrage.BaseArticle.EditeurInterne}}
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">No customers found.</td>
          </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
          <tr>
            <td colspan="7">Loading customers data. Please wait.</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
